import { MILES_IN_KILOMETERS } from 'global/appConstants';
import { getCompanyInfo, formatPhoneNum } from 'utils/helpers';

import { initialEmployeeFormData } from './EmployeeForm/EmployeeFormTabs/schema';

export const transformEmployeeDataToFormdata = (employeeApiData: any) => {
  const companyInfo = getCompanyInfo();

  const formData: typeof initialEmployeeFormData = {
    ...initialEmployeeFormData,
    user_id: employeeApiData?.userId || '',
    firstName: employeeApiData?.firstName || '',
    lastName: employeeApiData?.lastName || '',
    billing_rate_type: employeeApiData?.billing_rate_type ? '1' : '0',
    email: employeeApiData?.email || '',
    userPassword: employeeApiData?.password || '',
    notes: employeeApiData?.notes || '',
    color: employeeApiData?.color || '',
    employee_code: employeeApiData?.pinCode || '',
    companyEmployeeId: employeeApiData.companyEmployeeId || '',
    phone: formatPhoneNum(employeeApiData.phone ?? '') || '',
    hourlyRate: employeeApiData.payRate ?? '0',
    roleId: employeeApiData?.roleId ? { label: employeeApiData?.roleName, value: +employeeApiData?.roleId } : null,
    track_location: employeeApiData?.locationTracking ? ['yes'] : [],
    track_mileage: employeeApiData?.mileageTracking ? ['yes'] : [],
    sms_invite: employeeApiData?.sms_invite ? ['yes'] : [],
    groups: employeeApiData?.groups ? employeeApiData?.groups : [],
    timesheet_option: employeeApiData?.permissions?.manageTimesheets ? true : false,
    schedule_option: employeeApiData?.permissions?.manageSchedules ? true : false,
    job_option: employeeApiData?.permissions?.manageJobs ? true : false,
    report_option: employeeApiData?.permissions?.accessReports ? true : false,
    whoworking_option: employeeApiData?.permissions?.whoIsWorking ? true : false,
    view_only_assigned_jobs: employeeApiData?.permissions?.view_only_assigned_jobs ? true : false,
    employee_imagePreview: employeeApiData.employee_image || '',
    mileage_cost:
      companyInfo?.milesInKm && employeeApiData?.mileage_cost
        ? (employeeApiData.mileage_cost / MILES_IN_KILOMETERS).toFixed(2)
        : (employeeApiData?.mileage_cost ?? ''),
    daily_mileage_cap:
      companyInfo?.milesInKm && employeeApiData?.daily_mileage_cap
        ? (employeeApiData.daily_mileage_cap * MILES_IN_KILOMETERS).toFixed(2)
        : (employeeApiData?.daily_mileage_cap ?? ''),
    hire_date: employeeApiData?.hire_date ? new Date(employeeApiData.hire_date) : null,
  };

  return formData;
};
